import AppTemplate from './Template';

const module = new AppTemplate();

export default module;
